var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTires03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.77,
    height: 55.104,
    viewBox: "0 0 64.77 55.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 64.77,
    height: 55.104,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M46.128,35.5c-1.495-1.043-4.14-1.14-6.866-.279v5.837c2.98-.841,5.9-.638,7.643.582a4.268,4.268,0,0,1,.362.283V37.685A2.534,2.534,0,0,0,46.128,35.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M46.128,42.752c-1.495-1.043-4.14-1.14-6.866-.28V48.31c2.98-.841,5.9-.638,7.643.582a4.481,4.481,0,0,1,.362.283V44.938a2.534,2.534,0,0,0-1.139-2.186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M46.128,28.247c-1.495-1.044-4.14-1.14-6.866-.28v5.838c2.98-.841,5.9-.638,7.643.582.128.09.248.184.362.282V30.433a2.534,2.534,0,0,0-1.139-2.186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M46.128,13.742c-1.495-1.043-4.14-1.14-6.866-.279V19.3c2.98-.841,5.9-.638,7.643.582a4.481,4.481,0,0,1,.362.283V15.928a2.534,2.534,0,0,0-1.139-2.186"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 6.784,
    height: 55.104,
    transform: "translate(48.624 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M46.128,6.49c-1.495-1.044-4.14-1.14-6.866-.28v5.838c2.98-.841,5.9-.638,7.643.582a4.472,4.472,0,0,1,.362.282V8.676A2.534,2.534,0,0,0,46.128,6.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M46.128,21c-1.495-1.043-4.14-1.14-6.866-.28v5.838c2.98-.841,5.9-.638,7.643.582a4.268,4.268,0,0,1,.362.283V23.181A2.534,2.534,0,0,0,46.128,21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M57.9,42.752a2.534,2.534,0,0,0-1.139,2.186v4.237a4.482,4.482,0,0,1,.362-.283c1.748-1.22,4.663-1.423,7.643-.582V42.472c-2.726-.86-5.371-.763-6.866.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M57.9,13.742a2.534,2.534,0,0,0-1.139,2.186v4.237a4.482,4.482,0,0,1,.362-.283c1.748-1.22,4.663-1.423,7.643-.582V13.463c-2.726-.861-5.371-.764-6.866.279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M57.9,35.5a2.534,2.534,0,0,0-1.139,2.186v4.237a4.269,4.269,0,0,1,.362-.283c1.748-1.22,4.663-1.423,7.643-.582V35.22c-2.726-.861-5.371-.764-6.866.279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M39.262,3.577V4.8c2.98-.842,5.9-.639,7.643.582a4.472,4.472,0,0,1,.362.282V0h-3.44c-2.521,0-4.565,1.6-4.565,3.577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M46.128,50.005c-1.495-1.044-4.14-1.14-6.866-.28v1.8c0,1.975,2.044,3.577,4.565,3.577h3.44V52.191a2.534,2.534,0,0,0-1.139-2.186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M57.9,50.005a2.534,2.534,0,0,0-1.139,2.186V55.1h3.44c2.521,0,4.565-1.6,4.565-3.577v-1.8c-2.726-.86-5.371-.763-6.866.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M60.205,0h-3.44V5.66a4.33,4.33,0,0,1,.363-.283c1.747-1.22,4.662-1.423,7.642-.582V3.577C64.77,1.6,62.726,0,60.205,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M57.9,28.247a2.534,2.534,0,0,0-1.139,2.186v4.236c.114-.1.234-.192.362-.282,1.748-1.22,4.663-1.423,7.643-.582V27.967c-2.726-.86-5.371-.763-6.866.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M57.9,21a2.534,2.534,0,0,0-1.139,2.186v4.237a4.269,4.269,0,0,1,.362-.283c1.748-1.22,4.663-1.423,7.643-.582V20.715c-2.726-.86-5.371-.763-6.866.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M57.9,6.49a2.534,2.534,0,0,0-1.139,2.186v4.236a4.473,4.473,0,0,1,.362-.282c1.748-1.22,4.663-1.423,7.643-.582V6.21c-2.726-.86-5.371-.763-6.866.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M37.9,6.588V3.577a4.186,4.186,0,0,1,.264-1.456,27.553,27.553,0,1,0,0,50.861,4.19,4.19,0,0,1-.264-1.456v-5.2a21.438,21.438,0,1,1,0-37.549Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M37.9,17.918V10.546a19.9,19.9,0,1,0,0,34.012v-3.3a17.16,17.16,0,0,1-5.032,2.634,2,2,0,0,1-2.607-1.9V35.4a2.985,2.985,0,0,1,3.907-2.839L37.9,33.769V28.062L35.85,27.4A2.986,2.986,0,0,1,34.358,22.8ZM10.366,27.579v-.027a17.1,17.1,0,0,1,3.267-10.071,2,2,0,0,1,3.241-.009L20.747,22.8A2.985,2.985,0,0,1,19.254,27.4l-6.3,2.046a1.975,1.975,0,0,1-2.59-1.862M24.839,41.99a2,2,0,0,1-2.607,1.9,17.248,17.248,0,0,1-8.552-6.209,2,2,0,0,1,.986-3.093l6.265-2.036A2.986,2.986,0,0,1,24.839,35.4Zm9.005-27.715-3.877,5.336a2.985,2.985,0,0,1-4.83,0l-3.876-5.336a2,2,0,0,1,1.012-3.08,17.206,17.206,0,0,1,10.559,0,2,2,0,0,1,1.012,3.08"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTires03);
export default __webpack_public_path__ + "static/media/tires_03.7e6c69458615704398eee4ce1a8491e6.svg";
export { ForwardRef as ReactComponent };